import {
    appUrl,
    hasLead,
    phone, providerId,
    selectedAppointmentUnixTime,
    selectedCountry,
    setLeadInfo,
    setLeadTextId,
    visitorId
} from "../../utils/variables";
import { checkPageRegisterNewPatientsFormData } from "../actions/registerNewPatientActions";
import { toastError } from '../../views/components/error';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { createLead } from "../../services/leadServices";
import { appointmentItemsClickEventHandler } from "../actions/selectTimeActions";
import { goToServices } from "./validateDigitsListeners";

export async function registerNewPatientInputFieldListeners() {
    document.querySelectorAll('.register-new-patient__input input').forEach((element) => {
        element.addEventListener('input', checkContinueBtnState, false);
        element.addEventListener('keydown', onKeyDownInputRegisterNewPatient, false);
    });
    let datepicker = flatpickr("#dobDatepicker", {
        maxDate: 'today',
        dateFormat: "M d, Y",
        altInput: true,
        altFormat: "F j, Y",
    });
}

export async function registerNewPatientContinueBtnListeners() {
    let dobContinueBtnDom = document.querySelector('.register-new-patient-continue__btn');
    dobContinueBtnDom.addEventListener('click', onClickDobContinueBtn, false);
}

async function onClickDobContinueBtn() {
    let loaderIcon = document.querySelector('.register-new-patient-continue__btn .loader__icon');
    try {
        document.querySelector('.register-new-patient-continue__btn')?.classList.add('disabled');
        document.querySelector('.register-new-patient-continue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
        }
        let nameInputDoms = document.querySelectorAll('.register-new-patient__input input');
        let dobInputDom = document.getElementById('dobDatepicker');
        let data = {
            first_name: nameInputDoms[0].value,
            last_name: nameInputDoms[1].value,
            date_of_birth: dobInputDom.value,
            phone: parsePhoneNumberFromString(phone, selectedCountry).number,
            ...(visitorId && { visitor_id: visitorId })
        };

        let res = await createLead(data);
        setLeadTextId(res.data.text_id);
        setLeadInfo(res.data);
        await appointmentItemsClickEventHandler(selectedAppointmentUnixTime);
    } catch (error) {
        toastError(error.response?.data?.message);
    } finally {
        if (loaderIcon) {
            loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        }
        document.querySelector('.register-new-patient-continue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.register-new-patient-continue__btn')?.classList.remove('disabled');
    }
}

function checkContinueBtnState() {
    let continueBtnDom = document.querySelector('.register-new-patient-continue__btn');
    if (checkPageRegisterNewPatientsFormData()) {
        continueBtnDom?.classList.remove('disabled');
    } else {
        continueBtnDom?.classList.add('disabled');
    }
}

function onKeyDownInputRegisterNewPatient(event) {
    if (event.key === 'Tab') {
        event.stopPropagation();
    }
}